// import axios from "axios";
import { axiosInstance } from "../config/axios";

const handlerEnabled = true;

const endpoint = "/playoff/";

export const Create = async (params) => {
	try {
		const res = await axiosInstance.post("playoff/", params);
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getAllPlayoffs = async (row, page = 1, filters = {}) => {
	try {
		const res = await axiosInstance.get(endpoint, {
			params: { page_size: row, page: page, ...filters },
			handlerEnabled,
		});

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		console.log("====================================");
		console.log(e);
		console.log("====================================");
		const data = {
			success: false,
		};
		return data;
	}
};

export const getPlayoffDetails = async (id) => {
    try {
        const res = await axiosInstance.get(`new-playoff/${id}/`);

        const { data } = res;
        data["success"] = true;
        return res.data;
    } catch (e) {
        const data = {
            success: false,
        };
        return data;
    }
};
export const getPlayoffBuckets = async (
	page_size = 10,
	page = 1,
	search = {}
) => {
	const response = await axiosInstance.get("/playoff-buckets/", {
		params: {
			page_size,
			page,
			...search,
		},
	});

	return response.data;
};
export const createPlayoffBucket = (data) =>
    axiosInstance.post("/playoff-buckets/", data);
export const updatePlayoffBucket = (id, data) =>
    axiosInstance.patch(`/playoff-buckets/${id}/`, data);

export const getStylistUsers = async () => {
    try {
        const url = `stylist/`;
        const res = await axiosInstance.get(url);

        const { data } = res;
        data["success"] = true;
        return res.data;
    } catch (e) {
        const data = {
            success: false,
        };
        return data;
    }
};

export const setActiveInactivePlayoff = async (data) => {
    // const api = `listcategory/${data.id}/`;
    const res = await axiosInstance.put(`${endpoint}${data.id}/`, data);
    return res.data;
};

export const pinToTopPlayoff = async (data) => {
    // var form_data = new FormData();

    // form_data.append('pin_to_top', data.pin_to_top)
    // form_data.append('title',data.title)
    // form_data.append('is_playoff',data.is_playoff)
    // form_data.append('active',data.active)
    // console.log(data);
    const res = await axiosInstance.post(`/pin-to-top-playoff/`, data);
    return res.data;
};


export const deleteInfographic = async (id) => {
  try {
    await axiosInstance.delete(`infographics/${id}/`);

    return {
      success: true,
    };
  } catch (e) {
    return {
      success: false,
    };
  }
};
export const createInfographic = async (formData) => {
  try {
    const res = await axiosInstance.post("infographics/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    console.log(error);

    return {
      success: false,
      error,
    };
  }
};

export const updateInfographic = (id, formData) =>
    axiosInstance.put(`/infographics/${id}/`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

	// export const deleteInfographic = (id) =>
    // axiosInstance.delete(`/infographics/${id}/`);
export const UpdatePlayoff = async (params, id) => {
    try {
        const res = await axiosInstance.put(`${endpoint}${id}/`, params);
        console.log("====================================");
        console.log(res);
        console.log("====================================");
        const { data } = res;
        data["success"] = true;
        return res.data;
    } catch (e) {
        const data = {
            success: false,
        };
        return data;
    }
};

export const handleRetire = async (params, id) => {
    try {
        const res = await axiosInstance.post(`handle-retire/${id}`, params);
        console.log("====================================");
        console.log(res);
        console.log("====================================");

        return res;
    } catch (e) {
        const data = {
            success: false,
        };
        return data;
    }
};

export const getUserCountDetails = async (
    row,
    page = 1,
    filters = {},
    order_by = null
) => {
    try {
        const res = await axiosInstance.get("/details", {
            params: { page_size: row, page: page, order_by, ...filters },
            handlerEnabled,
        });
        console.log(res);
        return res.data;
    } catch (e) {
        console.log("====================================");
        console.log(e);
        console.log("====================================");
        const data = {
            success: false,
        };
        return data;
    }
};

export const send_playoff_notification = async (id) => {
    try {
        const res = await axiosInstance.get(`/playoff_notifications/${id}`);
        console.log(res);
        return res.data;
    } catch (e) {
        console.log("====================================");
        console.log(e);
        console.log("====================================");
        const data = {
            success: false,
        };
        return data;
    }
};

export const fetchAestheticList = async (query) => {
    const res = await axiosInstance.get(`/aesthetic/?q=${query}`);
    return res.data;
};

export const createAesthetic = async (data) => {
    const res = await axiosInstance.post(`/aesthetic/`, data);
    return res.data;
};
